









import { Component, Vue } from 'vue-property-decorator';
import MountainBox from '@/components/MountainBox.vue';
import { APPLICATION_USER_DATA } from '@/queries/Application';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_applicationUserData_currentUser } from '@/queries/__generated__/applicationUserData';
import Logo from './Logo.vue';

@Component({
  components: {
    MountainBox,
    Logo,
  },
})
export default class AppLoader extends Vue {
  @SmartQuery({
    query: APPLICATION_USER_DATA,
    result() {
      this.loaded = true;
    },
  }) private currentUser!: GQL_applicationUserData_currentUser;

  private loaded = false;
}
